(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-charging-extension-16"] && !Shopify.designMode) return;
  try {
    
class AtomicChargingExtension {
  constructor(section) {
    this.section = section;
    const data = section.querySelector('[data-product-json]');
    this.product = data ? JSON.parse(data.textContent) : null;
    this.form = section.querySelector('[data-aw-charge-form]');
    this.variantInput = section.querySelector('[data-aw-charge-variant-id]');
    this.price = section.querySelector('[data-aw-charge-price]');
    this.cards = Array.from(section.querySelectorAll('[data-aw-charge-variant-card]'));
    this.radios = Array.from(section.querySelectorAll('[data-aw-charge-variant-radio]'));
    this.mainImage = section.querySelector('[data-main-image]');
    this.thumbs = Array.from(section.querySelectorAll('[data-aw-charge-thumb]'));
    this.bindVariants();
    this.bindGallery();
  }

  bindGallery() {
    this.thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (!this.mainImage) return;
        this.mainImage.src = thumb.dataset.fullSrc;
        this.thumbs.forEach((item) => item.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  }

  bindVariants() {
    this.radios.forEach((radio) => {
      radio.addEventListener('change', () => {
        if (!radio.checked || !this.product) return;
        const variant = this.product.variants.find((item) => String(item.id) === String(radio.value));
        if (!variant) return;
        if (this.variantInput) this.variantInput.value = variant.id;
        this.cards.forEach((card) => card.classList.toggle('is-selected', card.contains(radio)));
        this.renderPrice(variant, radio);
        this.form.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  renderPrice(variant, radio) {
    if (!this.price) return;
    const money = (value) => {
      const amount = Number(value || 0) / 100;
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount);
    };
    const price = Number(radio?.dataset.awChargePrice || variant.price || 0);
    const comparePrice = Number(radio?.dataset.awChargeComparePrice || variant.compare_at_price || 0);
    const compare = comparePrice > price
      ? `<s class="aw-charge-product__price-compare">${money(comparePrice)}</s>`
      : '';
    this.price.innerHTML = `${compare}<span class="aw-charge-product__price-current">${money(price)}</span>`;
  }
}

document.querySelectorAll('[data-aw-charge-product]').forEach((section) => new AtomicChargingExtension(section));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-charging-extension"] && !Shopify.designMode) return;
  try {
    
class AtomicChargingExtension {
  constructor(section) {
    this.section = section;
    const data = section.querySelector('[data-product-json]');
    this.product = data ? JSON.parse(data.textContent) : null;
    this.form = section.querySelector('[data-aw-charge-form]');
    this.variantInput = section.querySelector('[data-aw-charge-variant-id]');
    this.price = section.querySelector('[data-aw-charge-price]');
    this.cards = Array.from(section.querySelectorAll('[data-aw-charge-variant-card]'));
    this.radios = Array.from(section.querySelectorAll('[data-aw-charge-variant-radio]'));
    this.mainImage = section.querySelector('[data-main-image]');
    this.thumbs = Array.from(section.querySelectorAll('[data-aw-charge-thumb]'));
    this.bindVariants();
    this.bindGallery();
  }

  bindGallery() {
    this.thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (!this.mainImage) return;
        this.mainImage.src = thumb.dataset.fullSrc;
        this.thumbs.forEach((item) => item.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  }

  bindVariants() {
    this.radios.forEach((radio) => {
      radio.addEventListener('change', () => {
        if (!radio.checked || !this.product) return;
        const variant = this.product.variants.find((item) => String(item.id) === String(radio.value));
        if (!variant) return;
        if (this.variantInput) this.variantInput.value = variant.id;
        this.cards.forEach((card) => card.classList.toggle('is-selected', card.contains(radio)));
        this.renderPrice(variant, radio);
        this.form.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  renderPrice(variant, radio) {
    if (!this.price) return;
    const money = (value) => {
      const amount = Number(value || 0) / 100;
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount);
    };
    const price = Number(radio?.dataset.awChargePrice || variant.price || 0);
    const comparePrice = Number(radio?.dataset.awChargeComparePrice || variant.compare_at_price || 0);
    const compare = comparePrice > price
      ? `<s class="aw-charge-product__price-compare">${money(comparePrice)}</s>`
      : '';
    this.price.innerHTML = `${compare}<span class="aw-charge-product__price-current">${money(price)}</span>`;
  }
}

document.querySelectorAll('[data-aw-charge-product]').forEach((section) => new AtomicChargingExtension(section));

  } catch(e) { console.error(e); }
})();
})();
